import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import '/Applications/MAMP/htdocs/projects/fiberdroid-site/public/webcomponent/node_modules/css-loader/dist/runtime/api.js'
import '/Applications/MAMP/htdocs/projects/fiberdroid-site/public/webcomponent/node_modules/vue-style-loader/lib/addStylesShadow.js'
import '/Applications/MAMP/htdocs/projects/fiberdroid-site/public/webcomponent/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js'

window.customElements.define('web-component-fiberdroid-coverage', wrap(Vue, () => import('~root/src/components/FiberdroidCoverage.vue?shadow')))

window.customElements.define('web-component-fiberdroid-model', wrap(Vue, () => import('~root/src/components/FiberdroidModel.vue?shadow')))

window.customElements.define('web-component-fiberdroid-quiz', wrap(Vue, () => import('~root/src/components/FiberdroidQuiz.vue?shadow')))

window.customElements.define('web-component-fiberdroid-test', wrap(Vue, () => import('~root/src/components/FiberdroidTest.vue?shadow')))